/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Billing cycle for the selected plan. Defaults to MONTHLY when omitted.
 */
export type CreateCompanyRequestBillingCycle = typeof CreateCompanyRequestBillingCycle[keyof typeof CreateCompanyRequestBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCompanyRequestBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const;
